var _path, _path2, _circle, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorizedNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    fill: "url(#tadbvk384a)",
    d: "M6.75 2.068H17.2v19.25H6.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.4 17.14 12.65.089m-10.1 4.37h7.3a2.4 2.4 0 0 0 2.4-2.4v-15a2.4 2.4 0 0 0-2.4-2.4h-7.3a2.4 2.4 0 0 0-2.4 2.4v15a2.4 2.4 0 0 0 2.4 2.4z",
    stroke: "url(#xk6pzutseb)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.693,
    cy: 19.438,
    r: 0.825,
    fill: "url(#ss2ynrmmhc)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.483,
    y: 3.406,
    width: 2.75,
    height: 0.825,
    rx: 0.412,
    fill: "url(#6z7tfcrzvd)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tadbvk384a",
    x1: 6.75,
    y1: 13.262,
    x2: 17.875,
    y2: 11.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xk6pzutseb",
    x1: 5.4,
    y1: 13.314,
    x2: 18.711,
    y2: 10.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ss2ynrmmhc",
    x1: 10.868,
    y1: 19.573,
    x2: 12.505,
    y2: 19.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6z7tfcrzvd",
    x1: 10.483,
    y1: 3.886,
    x2: 11.866,
    y2: 2.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizedNumber);
export default __webpack_public_path__ + "static/media/authorizedNumber.9ce3c1a147ac0c799662eb0274d47b33.svg";
export { ForwardRef as ReactComponent };